import { CicIndexResponse, SipConnection } from 'RtModels';
import { useGetSipConnection } from 'RtUi/app/rtSip/Connections/lib/services';
import {
	IRtxSelectInputInstanceProps,
	RtxSelectInput
} from 'RtUi/components/rtx/inputs/Select/RtxSelectInput';

export interface IRtxSipConnectionSelectProps<
	IsMulti extends boolean = false,
	IsClearable extends boolean = false
> extends IRtxSelectInputInstanceProps<
		SipConnection,
		'sipConnectionId',
		IsMulti,
		IsClearable
	> {}

export const RtxSipConnectionSelect = <
	IsMulti extends boolean = false,
	IsClearable extends boolean = false
>({
	displayMode,
	label = 'Carrier',
	...props
}: IRtxSipConnectionSelectProps<IsMulti, IsClearable>): JSX.Element => {
	const { data = [], isLoading } = useGetSipConnection();

	// Extract the array from FullResponse if necessary
	const options: SipConnection[] = Array.isArray(data)
		? data
		: data?.data ?? [];

	return (
		<RtxSelectInput<SipConnection, 'sipConnectionId', IsMulti, IsClearable>
			label={label}
			valueKey="sipConnectionId"
			labelKey="fullLabel"
			options={options}
			displayMode={displayMode}
			isLoading={isLoading}
			{...props}
		/>
	);
};
